import * as angular from "angular";
import {IController} from "angular";
import {MessagesService} from "../../services/messages-service.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {SmsNotificationType} from "../../enums/sms-notification.type";

export class smsMessagesViewCtrl implements IController {

  from: any;
  to: any;
  range: any;
  doDisplayQueries: boolean;

  public totalMessages: string;
  public isSmsNotificationTypeEnabled: boolean;
  public isWhatsappNotificationTypeEnabled: boolean;

  private notificationType: typeof SmsNotificationType = SmsNotificationType;
  private filterConfig: any;
  private messagesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;

  /* @ngInject */
  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $messages, private $infiniteScroll, private $log, private messagesService: MessagesService, private moment) {
  }

  $onInit() {
    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.doDisplayQueries ?
        ((this.from && this.to) ? {
          dateStart: this.from,
          dateEnd: this.to
        } : this.dateRangeTimeFiltersService.today()) : undefined,
      isSent: undefined,
      notificationType: undefined
    };
    this.messagesRef = this.$messages();
    this.loadLimit = 50;

    this.messagesRef.$query(this._getQueryPayload());
    this._getTotalMessages();
    this.infiniteScroll = this.$infiniteScroll(this.messagesRef, this.loadLimit, {getFullData: true});
  }

  onRangeChanged(range) {
    this.filterConfig.range = range;
    this._reloadQuery();
    this._getTotalMessages();
  }

  onFilterBySMSStatusClicked(selectedId) {
    this.filterConfig.isSent = selectedId;
    this._reloadQuery();
    this._getTotalMessages();
  }

  _reloadQuery() {
    this.messagesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      });
  }

  _getQueryPayload() {
    return {
      from: this.filterConfig.range?.dateStart,
      to: this.filterConfig.range?.dateEnd,
      limit: this.loadLimit,
      notificationType: this.filterConfig.notificationType,
      isSent: this.filterConfig.isSent
    }
  }

  onToggleIsShowSms(isSmsNotificationTypeEnabled){
    this.isSmsNotificationTypeEnabled = isSmsNotificationTypeEnabled;

    this._setNotificationType();
    this._reloadQuery();
    this._getTotalMessages();
  }

  onToggleIsShowWhatsapp(isWhatsappNotificationTypeEnabled){
    this.isWhatsappNotificationTypeEnabled = isWhatsappNotificationTypeEnabled;

    this._setNotificationType();
    this._reloadQuery();
    this._getTotalMessages();
  }

  private _getTotalMessages() {
    this.messagesService.getMessagesTotals(
        this.filterConfig.range?.dateStart,
        this.filterConfig.range?.dateEnd,
        this.filterConfig.isSent,
        this.filterConfig.notificationType
    )
      .then((totalMessages: any) => {
        this.totalMessages = totalMessages.total;
      })
      .catch((error) => {
        this.totalMessages = '---'
      });
  }

  private _setNotificationType() {
    this.filterConfig.notificationType = (this.isSmsNotificationTypeEnabled && this.isWhatsappNotificationTypeEnabled) ? undefined
        : (this.isSmsNotificationTypeEnabled ? this.notificationType.Sms : (this.isWhatsappNotificationTypeEnabled ? this.notificationType.Whatsapp : undefined));
  }

}

angular
  .module('bringoz.admin.messages')
  .component('smsMessagesView', {
    bindings: {
      isScrollable: '<?',
      from: '<?',
      to: '<?',
      doDisplayQueries: '<?',
      range: '<?'
    },
    template: require('./sms-messages-view.html').default,
    controller: smsMessagesViewCtrl,
  });
